import { lazy } from "react"

export const DeliveryAddressesPage = lazy(() => import("./DeliveryAddressesPage"))